import React, { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import axios from '../../../API/axios';
import { Link } from 'react-router-dom';
import { Row } from 'reactstrap';
import { ShimmerDiv } from 'shimmer-effects-react';

const AllCompanies = () => {
  // const [isLoading, setIsLoading] = useState(true);
  // const [companyList, setCompanyList] = useState([]); 

  // const getCompanyList = (page = 1) => {
  //   const data = { 
  //     pageNumber: page,
  //     pageSize: 10, 
  //   };

  //   axios
  //     .post(`/Company/GetAll?CompType=Company`, data) 
  //     .then((response) => {
  //       const res = response.data.responseData.companyList;
  //       console.log("company list====>",response.data.responseData.companyList);

  //       setCompanyList(res)
  //       setIsLoading(false);

  //     })
  //     .catch((error) => {
  //       console.log("error",error) 
  //     });
  // };

  // useEffect(() => { 
  //   getCompanyList(); // Initial fetch on mount
  // }, []);

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [jobList, setcmpnyList] = useState([]);
  const [searchcmpnyList, setSearchCmpnyList] = useState([]);
  const [searchcmpnyName, setSearchCmpnyName] = useState("");

  const [isError, setIsError] = useState(false);
  const [reset, setReset] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [nextBatchLoading, setNextBatchLoading] = useState('')


  const getAllCompanyList = (page, searchcmpnyName) => {
    setNextBatchLoading(true);

    const data = {
      pageNumber: page,
      pageSize: 10
    }

    axios
      .post(`/Company/GetAll?CompType=Company&Search=${searchcmpnyName}`, data)
      .then((response) => {
        const res = response.data.responseData.companyList;
        console.log("getAllCompanyList", response.data.responseData.companyList);
        setcmpnyList(res);
        setIsLoading(false);
        // setTotalPages(response.data.responseData.paging.totalPages);

        const newPosts = response.data.responseData.companyList;
        // console.log("newwwwposttt", newPosts);

        if (searchcmpnyName !== '') {
          setcmpnyList([])
          setSearchCmpnyList(newPosts)
        } else {
          setSearchCmpnyList([])
          setcmpnyList((prev) => {
            const jobSet = new Set(prev?.map((job) => job?.uid));
            const uniqueNewPosts = newPosts.filter(
              (job) => !jobSet.has(job?.uid)
            );
            return [...prev, ...uniqueNewPosts];
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setIsError(true);
        } else {
          console.log(error);
        }
        setIsLoading(false);
        setNextBatchLoading(false);
      });
  };
  useEffect(() => {
    if (page <= totalPages) {
      getAllCompanyList(page + 1);
    }
  }, [page]);

  useEffect(() => {
    setcmpnyList([]); // Reset job list when searchcmpnyName changes
    getAllCompanyList(1, searchcmpnyName); // Start from page 1 for a new search
  }, [searchcmpnyName]);


  const handleInfiniteScroll = async () => {
    try {
      if (window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight) {
        setLoading(true);
        console.log('log', page, totalPages);

        page < totalPages && setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, []);

  return (
    <section className={`inner-employer-section  PeopleSearch pt-5`}>
      <div className="container">
        <Tabs className="col-lg-12 tf-tab">
          <Row>
            <div className="wd-meta-select-job">
              <div className="wd-findjob-filer">
                <div className="group-select-display">
                </div>
                <div className="form-group-1 ">
                  <input
                    type="email"
                    className="form-control p-2"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Search Company"
                    onChange={(e) => {
                      setSearchCmpnyName(e.target.value);
                      getAllCompanyList();
                    }}
                    value={searchcmpnyName}

                  />
                </div>
              </div>
            </div>

          </Row>

          <Row>
            <div className="container ">
              <div className=" content-tab">
                <TabPanel className="inner" style={{
                  minHeight: isLoading || nextBatchLoading ? '600px' : 'auto',
                  height: 'auto',
                }}>
                  <div className="group-col-2">
                    {isLoading ? (
                      <div className="row mt-2">
                        <div className=" ">
                          <ShimmerDiv mode="light" height={400} width={'100%'} />
                        </div>
                        <div className="col-md-6">
                          <ShimmerDiv mode="light" height={400} width={'100%'} />
                        </div>
                        <div className="col-md-6 mt-2">
                          <ShimmerDiv mode="light" height={400} width={'100%'} />
                        </div>
                        <div className="col-md-6 mt-2">
                          <ShimmerDiv mode="light" height={400} width={'100%'} />
                        </div>
                        <div className="col-md-6 mt-2">
                          <ShimmerDiv mode="light" height={400} width={'100%'} />
                        </div>
                        <div className="col-md-6 mt-2">
                          <ShimmerDiv mode="light" height={400} width={'100%'} />
                        </div>
                      </div>
                    ) : isError ? (
                      <div className="mt-2 error-image-cont error-cont">
                        <img src='/' alt="404 Not Found" width={200} />
                      </div>
                    ) : (
                      searchcmpnyList.length === 0 ?
                        jobList &&
                        jobList?.map((company, index) => {
                          return (
                            <div key={company.compUid} className="employer-block style-2 cl2">
                              <div className="inner-box">
                                <div className="logo-company">
                                  <img src={company.logoImage} alt="jobtex" />
                                </div>
                                <div className="box-content">
                                  <div className="star">{/* Star ratings */}</div>
                                  <h3>
                                    <Link to={`/Companydetails/${company.uid} `}>{company.name}</Link>
                                    {/* <Link to={`/Companydetails/${company.uid}`}>{company.name}</Link>  */}

                                  </h3>
                                  <p className="info">
                                    <span className="icon-map-pin"></span>
                                    {company.name1}
                                  </p>
                                </div>
                                <div className="button-readmore">
                                  {/* <span className="icon-heart"></span> */}
                                  <button className="btn-employer">
                                    {/* {company.jobType} */}
                                    Follow
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        }
                        ) : searchcmpnyList &&
                        searchcmpnyList?.map((company, index) => {
                          return (
                            <div key={company.compUid} className="employer-block style-2 cl2">
                              <div className="inner-box">
                                <div className="logo-company">
                                  <img src={company.logoImage} alt="jobtex" />
                                </div>
                                <div className="box-content">
                                  <div className="star">{/* Star ratings */}</div>
                                  <h3>
                                    <Link to={`/Companydetails/${company.uid}`}>{company.name}</Link>

                                  </h3>
                                  <p className="info">
                                    <span className="icon-map-pin"></span>
                                    {company.name1}
                                  </p>
                                </div>
                                <div className="button-readmore">
                                  {/* <span className="icon-heart"></span> */}
                                  <button className="btn-employer">
                                    {/* {company.jobType} */}
                                    Follow
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })
                    )}
                    {nextBatchLoading && <div className="text-center">
                      {/* <img src={post?.loader} width={50} /> */}
                    </div>}
                  </div>
                </TabPanel>
              </div>
            </div>

          </Row>

        </Tabs>
      </div>
    </section>
  )
}

export default AllCompanies